import {
    addActivity,
    activityInfo,
    editActivity
} from "@/api/activity";

export default {
    data() {
        return {

        }
    },
    activated() {
        let activityId = this.$route.query.activityId;
        if (activityId) {
            this.$loading.show();
            activityInfo(activityId).then(res => {
                this.$loading.hide();
                if (res.code == 0) {
                    this.form = res.data;
                    let theTime = res.data.duration;
                    if (theTime > 60) {
                        this.minute = theTime;
                        theTime = parseInt(theTime % 60);
                        if (this.minute > 60) {
                            this.hour = parseInt(this.minute / 60);
                            this.minute = parseInt(this.minute % 60);
                            if (this.hour >= 24) {
                                //大于24小时
                                this.day = parseInt(this.hour / 24);
                                this.hour = parseInt(this.hour % 24);
                            }
                        }
                    }
                    if (res.data.type == 'TIMING_SIGN') {
                        let arr = res.data.timingTime.split(':');
                        this.timingHour = arr[0];
                        this.timingMinute = arr[1];
                    }
                } else {
                    console.log(res.msg)
                }
            })
        }
    },
    methods: {
        // 新增活动
        handleAdd(params) {
            if (!(params.name).trim()) {
                this.$message.error('活动名称不能为空');
                return
            }
            this.$loading.show();
            addActivity(params).then(res => {
                this.$loading.hide();
                if (res.code == 0) {
                    this.$message.success('活动已创建')
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleEdit(params) {
            if (!(params.name).trim()) {
                this.$message.error('活动名称不能为空');
                return
            }
            this.$loading.show();
            editActivity(params).then(res => {
                this.$loading.hide();
                if (res.code == 0) {
                    this.$message.success('活动已修改')
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.msg);
                }
            })

        }
    }
}